module.exports = __webpack_public_path__ + "img/Blumenwiese-768@2x.7d54ec03.jpg";